import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const actions = {
    async storeSubsidy({ commit, dispatch }, subsidyData) {
        let route = Laroute.route('franchise.setting.subsidy.store');

        startLoading(dispatch, 'save-subsidy');

        return await axios
            .post(route, subsidyData)
            .then(res => {
                endLoading(dispatch, 'save-subsidy');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-subsidy');
                throw err;
            });
    },

    async updateSubsidy({ commit, dispatch }, subsidyData) {
        startLoading(dispatch, 'save-subsidy');

        return await axios
            .patch(
                Laroute.route('franchise.setting.subsidy.update', {
                    id: subsidyData.id,
                }),
                subsidyData,
            )
            .then(res => {
                endLoading(dispatch, 'save-subsidy');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-subsidy');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    actions,
};
